import React from 'react';
import TestInfo from '../plp/TestInfo';
import topicinfoIcon from './images/testinfo.png';
import alertIcon from './images/alert.png';
import heymathIcon from '../../images/icons/heypractest_icon.png';
import Loader from 'react-loader-spinner';
import HmEventRegistry from '../../model/HmEventRegistry';
import ComponentRegistry from '../../model/ComponentRegistry';
import HmAjax from '../../util/HmAjax';

export default class ContestTestInfo extends TestInfo {
	constructor(props) {
		super(props);
		this.state = {			
			testInfoLoaded:false,
			topicInfoObj:{}
		};

		this.startTest = this.startTest.bind(this);
		this.trackTestStart = this.trackTestStart.bind(this);
		this.trackTestClose = this.trackTestClose.bind(this);
		this.contestId = this.props.contestId;
		this.roundTestId = this.props.roundTestId;
        this.timedTest = false;	

        this.close = (typeof props.close === "function") ? props.close : () => {};
	}

	startTest(){	
		if(this.state.topicInfoObj && this.props.contestId){
			let topicInfoObj = this.state.topicInfoObj;
			topicInfoObj.contestId = this.props.contestId || 0;
			topicInfoObj.currentQuestionId = topicInfoObj.currentQuestionId || topicInfoObj.questions[topicInfoObj.currentQNo-1].testQnId;
			this.props.callbackParent(topicInfoObj);
		}
    }
    
	componentWillMount(){
		this.props.onRef(undefined);
    }
    
	componentDidMount = () => {
		this.props.onRef(this);
		this.contestId = this.props.contestId;
        this.roundTestId = this.props.roundTestId;
        
        let formObj = {
            "contestId":this.contestId,
            "roundTestId":this.roundTestId
        }

        /**
		* dummyVal is for Testing purpose. REMOVE before hitting test env.
        */
        let dummyVal = window.ErrorPopUpTest || false;

		if(this.props.contestId > 0 && this.props.roundTestId > 0){				
			var me = this;
			var callBackSuccess = function(response){
				if(dummyVal || response.reqLocked === true || response.reqLocked === "true"){
					let prompter = {
					  "title": me.rb("test.creation.in_progress.title"),
					  "msg" : me.rb("test.creation.in_progress.msg"),
					  "status_code": 403,
					  "url" : null,
					  "buttons" : [{
					  	"label": me.rb("test.creation.in_progress.btn.ok"),
					  	"handler": me.close
					  }]
					};

					HmEventRegistry.fireEvent("ERROR_PROMPT",prompter);
				}else if(response.status === "success"){
					me.setState({testInfoLoaded:true,topicInfoObj:response.data});
					if(response && response.data && response.data.endTime && response.data.startTime){
						me.props.testTimedOutClose(response.data.startTime,response.data.endTime);
					}
					//me.loadTestInfo(response.data);
					
				}else if(response.code === 403 && response.message=="TEST_LOCKED"){
					//me.showAlert(' ',me.rb("test.locked"));
				}else{
					//alert("GET_TEST_ID Error:: "+me.rb("error.oops"));
				}
				
			}

			var callBackFailure = function(response){
				alert("GET_TEST_ID Error : ", response);				
			}


            new HmAjax(this.getUrlFor("CONTEST_TEST_TAKE"),formObj).post(callBackSuccess,callBackFailure);
				


		}else{
			//this.loadTestInfo(this.props.testId);
		}

		HmEventRegistry.fireEvent("INITIATE_GA_EVENT");  
    }
        
	loadTestInfo(testId){
		this.testId = testId;
		var me = this;
		var callBackSuccess = function(response){		
			//console.log(JSON.parse(response.data));
			if(response.code === 200){
				me.setState({testInfoLoaded:true,topicInfoObj:response.data});
				me.trackTestStart();				
			}else if(response.code === 403 && response.message=="TEST_LOCKED"){
				me.showAlert(' ',me.rb("test.locked"));
			}else{
				alert("GET_TEST_INFO Error:: "+me.rb("error.oops"));
			}
		}

		var callBackFailure = function(response){
			alert("GET_TEST_INFO Error : ", response);			
		}

		new HmAjax(this.getUrlFor("GET_TEST_INFO")+testId).put(callBackSuccess,callBackFailure);		
		
    }
    
	trackTestStart(){
		var postParams = {
			trackingDefId: 4,
			testId : this.testId,
			startTime : new Date().getTime(),
			action : this.state.topicInfoObj.status
		}
				
		var callBackSuccess = function(response){
		}

		var callBackFailure = function(error){
			console.log("Error in TRACK_SOLUTION");
		}

		new HmAjax(this.getUrlFor("TRACK_SOLUTION"),postParams).post(callBackSuccess,callBackFailure);
	}
	trackTestClose(){
		// try{
		// 	var postParams = {
		// 		"trackingDefId" : 4,
		// 		"testId" : this.testId,
		// 		"endTime" : new Date().getTime()				
		// 	}

		// 	var me = this;
		// 	var callBackSuccess = function(response){
		// 	}

		// 	var callBackFailure = function(error){
		// 		console.log("Error in TRACK_TEST_CLOSED");
		// 	}

		// 	new HmAjax(this.getUrlFor("TRACK_TEST_CLOSED"),postParams).post(callBackSuccess,callBackFailure);
		// }catch(e){}
	}
	getStatusText(){
		//console.log("this.state.topicInfoObj ",this.state.topicInfoObj);
		let UserTestStatus  = this.props.UserTestStatus || "UN_ATTEMPTED";
		if(UserTestStatus!=="UN_ATTEMPTED"){
			if(UserTestStatus == "IN_PROGRESS" || UserTestStatus == "NEW"){
				return this.rb("home.continue");
			}else{
				return this.rb("home.start");
			}
		}
		else{
			return this.rb("home.start");
		}
	}
	getTopicName(){
		var topicname = this.state.topicInfoObj.description;
		topicname = topicname.split("- Customized Practice").join("");		  
		return (topicname);
	}
	getMinutesStr(){
		var secsTime = !isNaN(this.state.topicInfoObj.duration) ? this.state.topicInfoObj.duration : 0;

		if(secsTime > 0){
			this.timedTest = true;
			var minutes = Math.floor(secsTime / 60);
			minutes = minutes + " Minutes";
			return (minutes);	
		}else{
			this.timedTest = false;
		}

		return 0;
	}

	getRemainingTime(){
		//console.log("lalala topicInfoObj ",this.state.topicInfoObj);
		let duration = !isNaN(this.state.topicInfoObj.duration) ? this.state.topicInfoObj.duration : 0;
		let ellapsedTime = !isNaN(this.state.topicInfoObj.userDuration) ? this.state.topicInfoObj.userDuration : 0;
		let remainingTime = Math.round((duration - ellapsedTime) / 60);

		let currentTime = Math.round((new Date().getTime()) / 1000);
		let endTime = !isNaN(this.state.topicInfoObj.endTime) ? this.state.topicInfoObj.endTime : 0;
		let reminTime = (remainingTime>0) ? remainingTime : 1;
		if(Math.round((endTime - currentTime )) > reminTime){
			return reminTime;
		}else{
			return Math.round((endTime - currentTime ) / 60)
		}
	}

	
	renderTestInfo(){
		if (this.state.testInfoLoaded === false) {
			return(
				<div className="text-center loadingAnim">
				<Loader 
				type="Oval"
				color="#00BFFF"
				height="100"	
				width="100"
				/>
				</div>
				)
			}else{
				return(
				<div className="row modalBase">
				<div className="col-md-4 text-center leftPanel">

				<div className="topicDetails">
				<div className="title">{this.state.topicInfoObj.title}</div>
				{/* <div className="topicName">{this.getTopicName()}</div> */}
				</div> 

				<span className="iconDiv">

				{( () => {
					if(this.state.topicInfoObj.testMode == 1 || this.state.topicInfoObj.testMode == "1"){
						return <img src={topicinfoIcon} />
					}else{
						return <img src={heymathIcon} />
					}
				}) ()}
				</span>

				</div>
				<div className="col-md-8 rightPanel">
				<div className="testInfo">
				<div className="row">
				<div className="col-md-9 col-9 caption">{this.rb("testinfo.totalquestions")}</div>
				<div className="col-md-3 col-3 nopadding bigNumbers text-right">{this.state.topicInfoObj.questionCount}</div>
				</div>

				{(() => {
					let UserTestStatus  = this.props.UserTestStatus || "UN_ATTEMPTED";
					if(this.getMinutesStr() && this.getMinutesStr().length > 0 && UserTestStatus === "UN_ATTEMPTED"){
						return (

				<div className="row totalDuration">
				<div className="col-md-6 col-6 caption">{this.rb("testinfo.duration")}</div>
				<div className="col-md-6 col-6 nopadding bigNumbers text-right">{this.getMinutesStr()}</div>
				</div>
						)
					}else if(this.getMinutesStr() && this.getMinutesStr().length > 0){
						return (

				<div className="row totalDuration">
				<div className="col-md-6 col-6 caption">{this.rb("testinfo.timeleft")}</div>
						<div className="col-md-6 col-6 nopadding bigNumbers text-right">{this.rb("testinfo.timeleftmin",[this.getRemainingTime()])}</div>
				</div>
						)
					}

				})()}


				<div className="float-right bottomBtns">
				<button type="button" className="btn btn-primary largeBtn" onClick={this.startTest} >
                {/* data-ga={"Post login - "+this.props.gradeName+" - Tests - "+this.state.topicInfoObj.title+" - "+this.getTopicName()+" - PT - "+this.getStatusText()} */}
				{this.getStatusText()}
				</button>
				</div>
				<div className="instruct">
				<span><img src={alertIcon} /></span>
				{( () => {
					let dynInstruct = this.state.topicInfoObj.instruction || this.rb("testinfo.instruction")
						return (
							<span>{dynInstruct}</span>
						)
				}) ()}
				
				</div>

				</div>						
				</div>					

				</div>
				)
			}

		}
		render = () => {
			return(				
			<div>
			{this.renderTestInfo()}
			</div>
			);
		}
	}


ComponentRegistry.register("ContestTestInfo",ContestTestInfo);


// WEBPACK FOOTER //
// ./src/views/contest/ContestTestInfo.js